import { useLang } from "@/context/LangContext";
import { useApi, gmapsDir } from "@/lib/api";
import MapView from "@/components/site/MapView";
import { PageHero } from "@/components/site/SectionHead";
import { RatingPill } from "@/components/site/DestinationCard";
import { Link } from "react-router-dom";
import { Navigation } from "lucide-react";

export default function MapPage() {
  const { t } = useLang();
  const { data } = useApi("/destinations");
  const list = data || [];
  return (
    <div data-testid="map-page">
      <PageHero title={t("sec_map")} sub={t("sec_map_sub")} />
      <section className="mx-auto grid max-w-7xl gap-6 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-8"><MapView points={list.map((d) => ({ ...d, subtitle: d.city }))} height="h-[640px]" /></div>
        <div className="lg:col-span-4 max-h-[640px] space-y-3 overflow-y-auto pr-1">
          {list.map((d) => (
            <div key={d.slug} data-testid={`map-list-${d.slug}`} className="flex gap-3 rounded-2xl border border-slate-200 bg-white p-3">
              <img src={d.image} alt={d.name} className="h-20 w-20 shrink-0 rounded-xl object-cover" />
              <div className="min-w-0 flex-1">
                <Link to={`/destinations/${d.slug}`} className="block truncate font-bold hover:underline">{d.name}</Link>
                <p className="text-xs text-slate-500">{d.city}</p>
                <RatingPill rating={d.rating} />
                <a href={gmapsDir(d.lat, d.lng)} target="_blank" rel="noreferrer" className="mt-1 flex items-center gap-1 text-xs font-bold text-[#064E3B]"><Navigation className="h-3 w-3" />{t("directions")}</a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
